<template>
  <div class="store-warpper">
    <store-container title="강원도" location="강원도" />
    <store-container title="경상도" location="경상도" />
    <store-container title="인천" location="인천" />
    <store-container title="울릉도" location="울릉도" />
    <store-container title="부산" location="부산" />
  </div>
</template>

<script>
import StoreContainer from "./store-container";
export default {
  components: { StoreContainer },
};
</script>

<style scoped>
.store-warpper {
  margin-bottom: 32px;
}
.content-header-container {
  display: flex;
  justify-content: space-between;
  height: 35px;
  margin-bottom: 10px;
}

.header-title-container {
  display: flex;
}

.content-title {
  font-size: 24px;
}

.content-subtitle {
  color: #f9730c;
  font-size: 24px;
}

p.indent {
  padding-left: 0.4em;
}

.content-title-more {
  color: grey;
  margin-top: 8px;
}

.horizontal-scroll {
  display: flex;
  width: 100%;
  height: 186px;
}

.outer {
  display: flex;
  flex: 1;
  width: auto;
  height: 100%;
  flex-flow: row nowrap;
}

.content-img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px #cbcbcb;
}

.inner-content a {
  box-shadow: 0px 1px 15px 0px #cbcbcb;
}

.inner-content {
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 120px;
  height: 150px;
  box-shadow: 0px 1px 15px 0px #cbcbcb;
}

@media (min-width: 640px) {
  .horizontal-scroll {
    height: 220px;
  }
  .inner-content {
    width: 150px;
    height: 180px;
  }
}

@media (min-width: 768px) {
  .horizontal-scroll {
    height: 250px;
  }
  .inner-content {
    width: 180px;
    height: 210px;
    box-shadow: 0px 1px 15px 0px #cbcbcb;
  }
}

@media (min-width: 1024px) {
  .horizontal-scroll {
    height: 280px;
  }

  .inner-content {
    width: 210px;
    height: 240px;
  }
}

.content-desc {
  margin-top: 6px;
  /* overflow: scroll;
  text-overflow: ellipsis; */
}

.inner-content:not(:first-of-type) {
  margin-left: 15px;
}
</style>
